import {
  ENewbuildingBrokerOfferBookingActions,
  TNewbuildingBrokerOfferBookingActions,
} from 'shared/actions/newbuildingBrokerOfferBooking';
import { INewbuildingBrokerOfferBooking } from 'shared/types/newbuildingBrokerOfferBooking';

const initialState: INewbuildingBrokerOfferBooking = {
  enabled: false,
  callbackWidgetOpened: false,
  galleryBannerAnalyticsSent: false,
  loading: false,
  bookingExistsModalOpened: false,
  professionalAccessBlockedModalOpened: false,
};

export const newbuildingBrokerOfferBookingReducer = (
  state: INewbuildingBrokerOfferBooking = initialState,
  action: TNewbuildingBrokerOfferBookingActions,
): INewbuildingBrokerOfferBooking => {
  switch (action.type) {
    case ENewbuildingBrokerOfferBookingActions.SetEnabled:
      return {
        ...state,
        enabled: action.payload,
      };

    case ENewbuildingBrokerOfferBookingActions.OpenCallbackWidget:
      return {
        ...state,
        callbackWidgetOpened: true,
        callbackWidgetClickType: action.payload,
      };

    case ENewbuildingBrokerOfferBookingActions.CloseCallbackWidget:
      return {
        ...state,
        callbackWidgetOpened: false,
        callbackWidgetClickType: undefined,
      };

    case ENewbuildingBrokerOfferBookingActions.SetGalleryBannerAnalyticsSent:
      return {
        ...state,
        galleryBannerAnalyticsSent: true,
      };

    case ENewbuildingBrokerOfferBookingActions.SetLoading:
      return {
        ...state,
        loading: action.payload,
      };

    case ENewbuildingBrokerOfferBookingActions.ToggleBookingExistsModal:
      return {
        ...state,
        bookingExistsModalOpened: action.payload,
        callbackWidgetOpened: !action.payload && state.callbackWidgetOpened,
      };

    case ENewbuildingBrokerOfferBookingActions.ToggleProfessionalAccessBlockedModal:
      return {
        ...state,
        professionalAccessBlockedModalOpened: action.payload,
      };

    default:
      return state;
  }
};
